import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import { LendoAppWrapper, APP_ROUTES } from "#common";

const App = () => {
  const appName = 'Finn beste kredittkort';

  return (
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <LendoAppWrapper basename={APP_ROUTES.CREDIT_CARD_MATCHER} useLayout>
        <Routes>
          <Route path="/" element={<Index appName={appName} />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </LendoAppWrapper>
    </TooltipProvider>
  );
};

export default App;
